module.exports = __webpack_public_path__ + "img/tobbysit.49135871.jpg";